import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { NotificationModule } from '../../notification/notification.module';
import { QuoteFeedComponent } from './quote-feed/quote-feed.component';
import { SlidePanelComponent } from './slide-panel.component';

@NgModule({
  declarations: [SlidePanelComponent,QuoteFeedComponent],
  imports: [CommonModule, ReactiveFormsModule, NotificationModule],

  exports: [SlidePanelComponent]
})
export class SlidePanelModule { }
